document.addEventListener('DOMContentLoaded',function(){
  var home=document.querySelector('.lv-homepage');
  if(!home)return;
  var checks=Array.prototype.slice.call(home.querySelectorAll('.lv-selector-grid input[type="checkbox"][data-key]'));
  var box=home.querySelector('.lv-package-match');
  if(!checks.length||!box)return;

  var packages=[
    {keys:['bls','pediatric'],title:'Adult, Child & Infant Coverage'},
    {keys:['first-aid-cpr-aed','severe-bleeding'],title:'Workplace Essentials'},
    {keys:['first-aid-cpr-aed','severe-bleeding','naloxone','recognition'],title:'Complete Workplace Response'},
    {keys:['bls','severe-bleeding','naloxone','recognition'],title:'Provider Plus'},
    {keys:['pediatric','severe-bleeding','recognition'],title:'Pediatric & Caregiver Complete'},
    {keys:['bls','pediatric','severe-bleeding','naloxone','recognition','lab'],title:'Provider Complete'}
  ];

  function selectedKeys(){return checks.filter(function(c){return c.checked;}).map(function(c){return c.getAttribute('data-key');});}
  function labelFor(key){var c=checks.find(function(x){return x.getAttribute('data-key')===key;});return c?c.value:key;}
  function findNear(keys){
    var hits=packages.map(function(p){
      var extras=keys.filter(function(k){return p.keys.indexOf(k)===-1;});
      var missing=p.keys.filter(function(k){return keys.indexOf(k)===-1;});
      if(extras.length===0&&missing.length===1)return {pkg:p,missing:missing[0],score:p.keys.length};
      return null;
    }).filter(Boolean);
    if(!hits.length)return null;
    hits.sort(function(a,b){return b.score-a.score;});
    return hits[0];
  }
  function clearNear(){
    if(box.dataset.matchKind==='near'){
      box.hidden=true;
      box.innerHTML='';
      delete box.dataset.matchKind;
    }
  }
  function render(){
    if(box.dataset.matchKind==='exact')return;
    var keys=selectedKeys();
    if(!keys.length){clearNear();return;}
    var near=findNear(keys);
    if(!near){clearNear();return;}
    box.dataset.matchKind='near';
    box.hidden=false;
    box.innerHTML='<div class="lv-package-match-label">One course away</div><div class="lv-package-match-grid"><div><h4>'+near.pkg.title+'</h4><p>Add <strong>'+labelFor(near.missing)+'</strong> and these selections match this existing Limen Vitalis package.</p></div><div class="lv-package-match-action"><button type="button" class="lv-btn lv-btn-primary lv-package-add" data-add-key="'+near.missing+'">Add this course</button></div></div>';
    var add=box.querySelector('[data-add-key]');
    if(add)add.addEventListener('click',function(){
      var key=this.getAttribute('data-add-key');
      var target=checks.find(function(c){return c.getAttribute('data-key')===key;});
      if(target){target.checked=true;target.dispatchEvent(new Event('change',{bubbles:true}));target.scrollIntoView({behavior:'smooth',block:'center'});}
    });
  }
  checks.forEach(function(c){c.addEventListener('change',function(){window.setTimeout(render,0);});});
  document.addEventListener('lv:training-selection-changed',function(){window.setTimeout(render,0);});
  render();
});
